import { createContext } from 'react';
import type { ListingDetailData } from '@/data/listing-details.data';

// Permet d'injecter un vrai deal (Firestore) dans ListingDetail.tsx sans
// muter le tableau module-level LISTING_DETAILS (qui grossissait
// indéfiniment et ne se rafraîchissait jamais pendant une session).
export const RealListingContext = createContext<ListingDetailData | null>(null);